import { Cartesian3 } from "cesium";
import { LinearSegment } from "../../geometric-elements/linear-segment";
import { BaseHorizontalAlignmentSegment } from "./horizontal-alignment-base-segment";
import { CurveDataType, } from "./interface";
export class HALinearSegment extends BaseHorizontalAlignmentSegment {
    type = CurveDataType.LINEAR;
    startPoint;
    endPoint;
    element;
    constructor(startPoint, endPoint) {
        super();
        this.startPoint = startPoint;
        this.endPoint = endPoint;
        this.recomputeElement();
    }
    isStartPoint(pointId) {
        return this.startPoint.id === pointId;
    }
    isEndPoint(pointId) {
        return this.endPoint.id === pointId;
    }
    get data() {
        return {
            startPointId: this.startPoint.id,
            endPointId: this.endPoint.id,
            type: CurveDataType.LINEAR,
        };
    }
    get surveyPoints() {
        return [this.startPoint, this.endPoint];
    }
    dispose() {
        if (this.previous) {
            this.previous.next = this.next;
        }
        if (this.next) {
            this.next.previous = this.previous;
        }
        this.element.dispose();
        this.startPoint = undefined;
        this.endPoint = undefined;
    }
    containsPointId(pointId) {
        return this.startPoint.id === pointId || this.endPoint.id === pointId;
    }
    recomputeElement() {
        this.element?.dispose();
        this.element = new LinearSegment(new Cartesian3(this.startPoint.localPoint.x, this.startPoint.localPoint.y, 0), new Cartesian3(this.endPoint.localPoint.x, this.endPoint.localPoint.y, 0));
    }
}
//# sourceMappingURL=horizontal-alignment-linear-segment.js.map